/**
 * Copyright (c) 2016-2020 Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti
 * All Rights Reserved.
 *
 * The software and data contained herein are confidential and
 * proprietary information of Yega Yazilim ("Confidential Information").
 *
 * Users of this software may not disclose such Confidential Information
 * and shall use it only in accordance with the terms of the license agreement
 * they entered into with Yega Yazilim.
 *
 *
 * Author    Ahmet Dogramaci
 * Date      2020-03-16
 */
import ActionExpression from "../enums/action-expression";

class ConfigurationTemplateDecisionAction {
    constructor() {
        this.condition_satisfied_exprsn = ActionExpression.SELECT;
        this.condition_not_satisfied_exprsn = null;
        this.node_object = null;
        this.decision_object = null;
    }

    buildFromJson(json_object){
        this.id = json_object.id;
        this.condition_satisfied_exprsn = json_object.condition_satisfied_exprsn;
        this.condition_not_satisfied_exprsn = json_object.condition_not_satisfied_exprsn;
        this.node = this.decision.template_version.getNodeById(json_object.cfg_template_node_id);
        this.node.addDecisionAction(this);
    }

    get decision(){
        return this.decision_object;
    }

    set decision(value){
        this.decision_object = value;
    }

    get node(){
        return this.node_object;
    }

    set node(node_in){
        this.node_object = node_in;
    }

    executeAction(isConditionSatisfied){
        console.log(`executeAction for decision :${this.decision.name}, node:${this.node.code} is ${isConditionSatisfied}`);
        if(isConditionSatisfied){
            this.node.addTrace("Decision:"+this.decision.name+", executing condition satisfied: "+this.condition_satisfied_exprsn);
            this.action(this.condition_satisfied_exprsn);
        }else{
            this.node.addTrace("Decision:"+this.decision.name+", executing executing condition not satisfied: "+this.condition_not_satisfied_exprsn);
            this.action(this.condition_not_satisfied_exprsn);
        }
    }

    action(expression) {
        switch (expression) {
            case ActionExpression.SELECT:
                console.log(`executeAction for decision :${this.decision.name}, selecting node:${this.node.code}`);
                this.node_object.select();
                break;
            case ActionExpression.UNSELECT:
                console.log(`executeAction for decision :${this.decision.name}, unselecting node:${this.node.code}`);
                this.node_object.unselect();
                break;
            case ActionExpression.HIDE:
                console.log(`executeAction for decision :${this.decision.name}, hiding node:${this.node.code}`);
                this.node_object.hide();
                break;
            case ActionExpression.SHOW:
                console.log(`executeAction for decision :${this.decision.name}, showing node:${this.node.code}`);
                this.node_object.show();
                break;
        }
    }
}
export default ConfigurationTemplateDecisionAction;